import Button from '@material-ui/core/Button';
import { BACKGROUND_TYPES, BackgroundContainer } from 'components/Background';
import { Flex, Padding } from 'components/base/layout-components';
import React from 'react';
import Text from 'components/base/Text';
import { CharacterPartyDude } from '@linearb/linui-common';
import Icon from '../base/Icon';
import { StyledBackground } from 'views/root/views/home/views/dashboard/Dashboard.style';
import { LockedTopBar } from './LockedTopBar';
import { logOut } from 'common/services/auth.service';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';

const ReloginSystem = ({ forceLogoutTimestamp }) => {
  const localStorageAccessor = BrowserStorageAccessor().local;

  return (
    <>
      <LockedTopBar />
      <StyledBackground>
        <BackgroundContainer
          justify='center'
          type={BACKGROUND_TYPES.EMPTY_DASHBOARD}
          items='center'
        >
          <Flex direction='column'>
            <Flex justify='center' pl='8rem'>
              <CharacterPartyDude />
            </Flex>
            <Flex direction='column' items='center'>
              <Text pt='2rem' size='x-x-x-large' weight='300'>
                We’ve made some improvements!
              </Text>
              <Text pt='0.5rem' size='x-x-x-large' weight='300'>
                Please log back in.
              </Text>
              <Padding padding='big'>
                <Button
                  size='large'
                  variant='contained'
                  onClick={() => {
                    localStorageAccessor.set(
                      LOCAL_STORAGE_KEYS.FORCE_LOGOUT_TIMESTAMP,
                      forceLogoutTimestamp
                    );

                    logOut();
                  }}
                >
                  <Icon
                    name='arrowleft'
                    color='white'
                    style={{ paddingRight: '0.6rem' }}
                  />{' '}
                  Back to Log in
                </Button>
              </Padding>
            </Flex>
          </Flex>
        </BackgroundContainer>
      </StyledBackground>
    </>
  );
};

export default ReloginSystem;
